import { useQuery } from '@shared/modules/use-query/hooks'
import { ProductSelect } from '../types'
import { useCallback, useMemo } from 'react'
import { ProductsService } from '../services'

export const useProductList = () => {
  return useQuery<ProductSelect[]>(
    useCallback(async () => {
      const result = await ProductsService.getSelect()
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
